<div class="sp-sector-switcher"
     *ngIf="shouldRender && activePack"
     [class.sp-switcher--interactive]="isInteractive"
     [class.sp-switcher--dev]="mode === 'dev'"
     (click)="toggleDropdown()">

  <div class="sp-switcher__badge"
       [style.background]="activePack.accentColor + '1A'"
       [style.color]="activePack.accentColor">
    {{ badgeText }}
  </div>

  <div class="sp-switcher__meta">
    <div class="sp-switcher__label">
      <span *ngIf="mode === 'demo'">Pack</span>
      <span *ngIf="mode === 'dev'">Dev pack</span>
    </div>
    <div class="sp-switcher__name">{{ activePack.packName }}</div>
  </div>

  <span class="sp-switcher__caret" *ngIf="isInteractive">▾</span>

  <div class="sp-switcher__dropdown"
       *ngIf="dropdownOpen && isInteractive"
       (click)="$event.stopPropagation()">

    <div class="sp-switcher__dropdown-header">Switch active pack</div>

    <div class="sp-switcher__option"
         *ngFor="let p of availablePacks"
         [class.sp-option--active]="p.packId === activePack.packId"
         (click)="switchTo(p)">

      <div class="sp-switcher__option-badge"
           [style.background]="p.accentColor + '1A'"
           [style.color]="p.accentColor">
        {{ p.packName.substring(0, 2).toUpperCase() }}
      </div>

      <div class="sp-switcher__option-name">{{ p.packName }}</div>

      <span class="sp-switcher__option-active"
            *ngIf="p.packId === activePack.packId">Active</span>
    </div>
  </div>
</div>
